export const ORGANIZATION_TOASTS = {
  ADDRESS_UPDATED: `Billing Address Updated`,
  ORGANIZATION_UPDATED: 'Organization successfully updated',
};
